import React, { useEffect, useState } from "react";
import clsx from "clsx";
import styles from "./styles/ComingSoonPage.module.css";
import { InputField } from "@components/Input/InputField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Form } from "react-bootstrap";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";

const validateSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email Address is required"),
});

const initialValues = { email: "" };

const ComingSoonPage = () => {
  const { handleSubmit, handleChange, handleBlur, values, errors, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validateSchema,
      onSubmit: (values) => {
        console.log(values);
        // if (values.isAccept === true) {
        //   // navigate("/sign-up-step", { state: values });
        // }
      },
    });
  const [times, setTimes] = useState([
    {
      name: "Days",
      time: 99,
    },
    {
      name: "Hours",
      time: 1,
    },
    {
      name: "Minutes",
      time: 1,
    },
    {
      name: "Seconds",
      time: 3,
    },
  ]);

  const decreaseTime = () => {
    let secondTemp = times[3].time;
    let minuteTemp = times[2].time;
    let hourTemp = times[1].time;
    let dayTemp = times[0].time;
    if (dayTemp + hourTemp + minuteTemp + secondTemp !== 0) {
      if (secondTemp - 1 < 0) {
        secondTemp = 59;
        if (minuteTemp - 1 < 0) {
          minuteTemp = 59;
          if (hourTemp - 1 < 0) {
            hourTemp = 23;
            if (dayTemp > 0) {
              dayTemp -= 1;
            }
          } else {
            hourTemp -= 1;
          }
        } else {
          minuteTemp -= 1;
        }
      } else {
        secondTemp -= 1;
      }
    }

    setTimes([
      {
        name: "Days",
        time: dayTemp,
      },
      {
        name: "Hours",
        time: hourTemp,
      },
      {
        name: "Minutes",
        time: minuteTemp,
      },
      {
        name: "Seconds",
        time: secondTemp,
      },
    ]);
  };

  useEffect(() => {
    setTimeout(() => {
      decreaseTime();
    }, 1000);
  }, [times]);

  const { width } = useWindowSize();

  return (
    <div className={clsx(styles.container)}>
      <div
        className={clsx(styles.timeContainer, {
          [styles.timeContainerMobile]: width < 768,
        })}
      >
        {times.map((value, key) => {
          return (
            <div key={"key " + key} className={clsx(styles.subTimeContainer)}>
              <span className={clsx(styles.timeCount)}>{`${
                width > 768
                  ? key !== times.length - 1
                    ? `-${value.time} : `
                    : `-${value.time}`
                  : `${value.time}`
              }`}</span>
              <span className={clsx(styles.timeTitle)}>{value.name}</span>
            </div>
          );
        })}
      </div>

      <div className={clsx(styles.notiContainer)}>
        <span className={clsx(styles.notiText)}>{"We'll be coming soon!"}</span>
        <Form
          noValidate
          onSubmit={handleSubmit}
          className={clsx(styles.inputNotifyContainer, {
            [styles.inputNotifyContainerMobile]: width < 600,
          })}
        >
          <InputField
            name={"email"}
            type={"email"}
            placeholder="Email Address"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="off"
            touchedValue={touched.email}
            errorsValue={errors.email}
          />
          <button
            type="submit"
            className={clsx("btn", styles.buttonNotify, "text-white")}
            style={{ backgroundColor: "var(--color-primary)" }}
          >
            Notify Me
          </button>
        </Form>
      </div>
    </div>
  );
};

/* required: display name */
ComingSoonPage.displayName = "ComingSoonPage";

/* required: props types */
ComingSoonPage.propTypes = {};

/* required: default props */
ComingSoonPage.defaultProps = {};

export { ComingSoonPage };
